import styled from "styled-components";
import {flexGrowItem} from "../../../../themes/architecture/css-helpers/flex";

export const JackpotToastTitleWrapperDefaultBox = styled.div`
    ${flexGrowItem};
    position: relative;
`;
